import { DataService } from './shared/service/data.service';
import { globalService } from './shared/service/global.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class AdminGuard implements CanActivate {
    constructor(
        private router:Router,
        private globServ:globalService,
        private _serv:DataService
        ){}
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ) : boolean{

        let token = this.globServ.shaToken;
        if(!this._serv.notNull(token)){
            localStorage.setItem('last_url', state.url)
            this.router.navigate(['/guest/signin'])
            return false;
        }else{
            const helper = new JwtHelperService();
            const isExpired = helper.isTokenExpired(token);
            if(isExpired){
                this.globServ.shaToken='';
                this.router.navigate(['/guest/signin'])
                return false;
            }
        }
        return true;
    }

}